// extracted by css-extract-rspack-plugin
export default {"ViolationsListSummary":"ViolationsList-module__ViolationsListSummary___N0k6it"};